export default __webpack_public_path__ + "static/media/resume.c95b70f6.pdf";